// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1hOut","col":"styles_col__3vOtI"};